import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Add token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mharher_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('mharher_token');
      // Optionally redirect to login
      // window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export default api;
